// extracted by mini-css-extract-plugin
module.exports = {"entitlementDays":"EntitlementDeal_entitlementDays__1ynX-"};